import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation, Trans } from 'react-i18next';

import { Flex, Image, Text, ButtonFilled } from 'Components/Base';

const ClearFileSizeExceedContent = ({ onContinue, maximumFileSize }) => {
  const { t } = useTranslation('classroom');
  return (
    <Flex width={1} flexDirection={'column'} alignItems={'center'} height="100%">
      <Image maxWidth={140} src="/assets/images/classroom/clearErrorModal.svg" />
      <Flex width={1} flexDirection={'column'} alignItems={'center'}>
        <Text textStyle={'heading2'} mt={6} textAlign={'center'}>
          {t('CLEAR_BY_LEARNED.FILE_SIZE_EXCEED_MODAL.TITLE')}
        </Text>
        <Text mt={4} textAlign={'center'}>
          <Trans
            defaults={t('CLEAR_BY_LEARNED.FILE_SIZE_EXCEED_MODAL.DESCRIPTION', {
              maximumFileSize,
            })}
            components={[<br key="subtitle" />]}
          />
        </Text>
      </Flex>
      <ButtonFilled
        onClick={onContinue}
        mt={'auto'}
        width={1}
        borderRadius="8px"
        maxWidth={'300px'}
      >
        {t('CLEAR_BY_LEARNED.FILE_SIZE_EXCEED_MODAL.CONTINUE')}
      </ButtonFilled>
    </Flex>
  );
};

ClearFileSizeExceedContent.propTypes = {
  onContinue: PropTypes.func,
  maximumFileSize: PropTypes.string,
};

export default ClearFileSizeExceedContent;
